
import { defuFn } from '/vercel/path0/node_modules/.pnpm/defu@6.1.2/node_modules/defu/dist/defu.mjs'

const inlineConfig = {
  "ui": {
    "primary": "green",
    "gray": "cool",
    "colors": [
      "red",
      "orange",
      "amber",
      "yellow",
      "lime",
      "green",
      "emerald",
      "teal",
      "cyan",
      "sky",
      "blue",
      "indigo",
      "violet",
      "purple",
      "fuchsia",
      "pink",
      "rose",
      "primary",
      "blue-gray",
      "navy",
      "coral",
      "skyblue"
    ]
  }
}

import cfg0 from "/vercel/path0/app.config.ts"
import cfg1 from "/vercel/path0/node_modules/.pnpm/@nuxthq+ui@2.5.0_vue@3.3.4_webpack@5.88.1/node_modules/@nuxthq/ui/dist/runtime/app.config.mjs"

export default /* #__PURE__ */ defuFn(cfg0, cfg1, inlineConfig)
